import { useEffect, useState } from "react";
import { Storage } from "aws-amplify";

export function useGetImages(imageSrc) {
  const [imagePath, setImagePath] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (imageSrc) {
        const source = imageSrc.replace("protected/", "");
        const identityId = source.match(/(eu-west-[^/]+)/)[0];
        const key = source.substring(
          source.indexOf(identityId) + identityId.length + 1
        );

        const url = key
          ? await Storage.get(key, { identityId, level: "protected" })
          : null;

        setImagePath(url);
      } else {
        setLoading(false);
      }
    })();
  }, [imageSrc]);

  return {
    imagePath,
    loading,
  };
}
